<template>
	<b-modal
		ref="preparation-incidences-modal"
		:title="`Incidencias de Preparación`"
		no-close-on-backdrop
		centered
		@hidden="handleHidden"
		size="xmd"
		hide-footer
	>
		<div>
			<b-nav tabs>
				<b-nav-item
					v-for="tab in tabs"
					:key="`tabx-${tab.id}`"
					@click="changeTab(tab.id)"
					:active="tab.id === tabId"
				>
					{{ tab.name }}
				</b-nav-item>
			</b-nav>
			<b-row class="mb-1">
				<b-col class="d-flex align-items-center">
					<small class="text-secondary">
						Mostrando {{ pagination.from }} a {{ pagination.to }} de {{ pagination.total }} registros
					</small>
				</b-col>
				<b-col class="d-flex align-items-center justify-content-end flex-wrap gap-x-4 gap-y-1">
					<b-pagination
						v-model="pagination.curPage"
						:total-rows="pagination.total"
						:per-page="pagination.perPage"
						first-number
						last-number
						class="mb-0 mt-1 mt-sm-0"
						prev-class="prev-item"
						next-class="next-item"
					>
						<template #prev-text>
							<feather-icon icon="ChevronLeftIcon" size="18" />
						</template>
						<template #next-text>
							<feather-icon icon="ChevronRightIcon" size="18" />
						</template>
					</b-pagination>
				</b-col>
			</b-row>
			<b-row class="mb-1">
				<b-col cols="12" xl="7" class="d-flex align-items-center justify-content-start mb-md-0">
					<label>Mostrar</label>
					<v-select
						v-model="pagination.perPage"
						:options="perPageOptions"
						:clearable="false"
						class="per-page-selector d-inline-block mx-50"
						style="width: 90px"
					/>
					<label class="mr-2">registros</label>
					<feather-icon class="cursor-pointer" icon="RefreshCcwIcon" size="20" @click="refresh" />
				</b-col>
				<b-col cols="12" xl="5">
					<div class="container-btns-page-specimens">
						<b-input-group id="incidence-input-group">
							<b-form-input
								v-model="search"
								class="d-inline-block"
								placeholder="Por placa o alias"
								@keyup.enter="handleInputSearch"
								debounce="500"
							/>
							<b-input-group-append>
								<b-button variant="outline-primary" @click="handleInputSearch()">
									<feather-icon class="cursor-pointer" icon="SearchIcon" />
								</b-button>
							</b-input-group-append>
						</b-input-group>
					</div>
				</b-col>
			</b-row>
			<b-table-simple responsive sticky-header="60vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-th class="text-center">Ejemplar</b-th>
					<b-th class="text-center">Incidencia</b-th>
					<b-th class="text-center">Estado Previo</b-th>
					<b-th class="text-center">Creado por</b-th>
					<b-th v-if="tabId == 1" class="text-center">Action</b-th>
					<b-th v-if="tabId == 2" class="text-center">Estado Final</b-th>
					<b-th v-if="tabId == 2" class="text-center">Finalizado por</b-th>
				</b-thead>
				<b-tbody>
					<template v-if="rows.length > 0">
						<b-tr v-for="(row, index) in rows" :key="index">
							<b-td class="text-center">
								<SpecimenPlate :specimen="row.specimen" show_status />
							</b-td>
							<b-td class="text-center">
								<span>
									{{ row.incidence_name }}
								</span>
							</b-td>
							<b-td class="text-center">
								<span>{{ getTrainingStatusName(row.training_status_id) }}</span>
							</b-td>
							<b-td class="text-center">
								<div>{{ row.creator_name }}</div>
								<div>{{ row.created_at | myGlobalDayWithHour }}</div>
							</b-td>
							<b-td v-if="tabId == 1" class="text-center">
								<b-button
									v-b-tooltip.hover
									title="Enviar a"
									size="sm"
									variant="flat-primary"
									@click="openStatusSelector(row)"
								>
									<FeatherIcon
										icon="SendIcon"
										class="text-primary"
										style="width: 1.2rem; height: 1.2rem"
									/>
								</b-button>
							</b-td>
							<b-td v-if="tabId == 2" class="text-center">
								<span>{{ getTrainingStatusName(row.new_status_id) }}</span>
							</b-td>
							<b-td v-if="tabId == 2" class="text-center">
								<div>{{ row.updated_by_name }}</div>
								<div>{{ row.updated_at | myGlobalDayWithHour }}</div>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="rows.length === 0">
						<b-td colspan="10" class="text-center" style="height: 80px">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
			<b-modal
				v-model="showSelectStatusModal"
				title="Seleccionar Estado"
				centered
				@hidden="showSelectStatusModal = false"
				size="md"
				no-close-on-backdrop
			>
				<b-form-group label="Nuevo Estado">
					<v-select
						v-model="statusId"
						:options="[
							{ id: 1, name: 'EN PROCESO' },
							{ id: 2, name: 'PRE-LISTOS' },
							{ id: 6, name: 'TRIP' },
						]"
						:clearable="false"
						label="name"
						:reduce="(option) => option.id"
					>
						<template v-slot:option="option">
							<div class="d-flex justify-content-between align-items-center">
								<span>{{ option.name }}</span>
							</div>
						</template>
					</v-select>
				</b-form-group>
				<template #modal-footer>
					<b-button @click="showSelectStatusModal = false" variant="secondary">Cancelar</b-button>
					<b-button variant="outline-primary" @click="leaveIncidence" :disabled="isLoading">
						<b-spinner small v-if="isLoading" />
						Guardar
					</b-button>
				</template>
			</b-modal>
		</div>
	</b-modal>
</template>

<script>
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import PreparacionService from "@/services/preparacion/default.service.js"
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue"
import { mapActions } from "vuex"
export default {
	components: { SpecimenPlate, FeatherIcon },
	props: {
		currentGroup: {
			type: Number,
			default: 1,
		},
	},
	data() {
		return {
			isLoading: false,
			rows: [],
			showSelectStatusModal: false,
			statusId: null,
			selectedRow: {
				training_id: null,
				tracking_id: null,
			},
			perPageOptions: [10, 25, 50],
			pagination: {
				total: 0,
				curPage: 1,
				perPage: 25,
				from: 0,
				to: 0,
			},
			search: "",
			tabs: [
				{
					id: 1,
					name: "Pendientes",
				},
				{
					id: 2,
					name: "Finalizadas",
				},
			],
			tabId: 1,
		}
	},
	async created() {
		await this.getDetails()
	},
	computed: {},
	methods: {
		...mapActions({
			A_GET_INCIDENCES_COUNTER: "commons/A_GET_INCIDENCES_COUNTER",
		}),
		changeTab(tabId) {
			this.tabId = tabId
			this.search = ""
			this.getDetails()
		},
		handleInputSearch() {
			this.getDetails()
		},
		refresh() {
			this.getDetails()
		},
		openStatusSelector(row) {
			this.selectedRow.training_id = row.training_id
			this.selectedRow.tracking_id = row.tracking_id
			this.showSelectStatusModal = true
		},
		getTrainingStatusName(statusId) {
			if (!statusId) return "SIN ESTADO"
			if (statusId == 1) return "EN  PROCESO"
			if (statusId == 2) return "PRE-LISTOS"
			if (statusId == 3) return "CANCELADO"
			if (statusId == 6) return "TRIP"
		},
		async refresh() {
			await this.getDetails()
		},
		handleHidden() {
			this.isLoading = false
			this.$emit("closing")
		},
		async getDetails(page = 1) {
			this.isPreloading()
			try {
				const { data } = await PreparacionService.getTrainingWithIncidences({
					page: page,
					per_page: this.pagination.perPage,
					search: this.search,
					tab_id: this.tabId,
					group_id: this.currentGroup,
				})
				this.rows = data.data
				this.pagination.curPage = data.current_page
				this.pagination.total = data.total
				this.pagination.from = data.from
				this.pagination.to = data.to
			} catch (error) {
				console.log(error)
			} finally {
				this.isPreloading(false)
			}
		},
		async leaveIncidence() {
			try {
				if (!this.statusId) return
				this.isLoading = true
				await PreparacionService.leaveIncidence({
					training_id: this.selectedRow.training_id,
					status_id: this.statusId,
					tracking_id: this.selectedRow.tracking_id,
				})
				this.$emit("refresh")
				await this.getDetails()
				this.A_GET_INCIDENCES_COUNTER()
				this.showSelectStatusModal = false
			} catch (error) {
				console.error(error)
			} finally {
				this.isLoading = false
			}
		},
	},
	async mounted() {
		this.$refs["preparation-incidences-modal"].toggle()
	},
	watch: {
		"pagination.curPage": async function () {
			await this.getDetails(this.pagination.curPage)
		},
		"pagination.perPage": async function () {
			await this.getDetails()
		},
	},
}
</script>

<style>
.label-filter {
	font-size: 0.8rem;
}

.nav.nav-tabs {
	flex-wrap: nowrap;
	overflow-x: auto;
	padding-bottom: 0.5rem;
}

.nav-link {
	white-space: nowrap;
}
</style>
